import { createFileRoute } from "@tanstack/react-router";
import LoadingPage from "lib/components/layout/LoadingPage";
import { useFeatures, useProducts } from "lib/security/client";
import { useUserContext } from "lib/state/UserContextProvider";

/**
 * Public buyer configurator for an unsaved plan. Loads a master / community
 * plan via the `public-plans` API and surfaces the CTA modal that creates a
 * new `HomePlan` on submit.
 */
function ShowroomConfigure() {
  const { builder, builderLoading } = useUserContext();
  useFeatures(!!builderLoading, ["showroomUnification"]);
  useProducts(builder, !!builderLoading, ["showroom"]);
  return <LoadingPage pageTitle="Showroom" />;
}

export const Route = createFileRoute("/showroom/")({
  component: ShowroomConfigure,
  staticData: { isPublicPage: true },
  // TODO: handle showroomPlanViewerOnly query param
});
